<template>
  <div class="invoice-form">
    <!-- 顶部栏 -->
    <div class="form-header">
      <span class="back-btn" @click="handleBack">
        <i class="el-icon-arrow-left"></i>
      </span>
      <span class="header-title">{{ $t('rosRecharge.issueEInvoice') }}</span>
    </div>
    <!-- 表单内容 -->
    <div class="form-body">
      <div class="form-content">
        <!-- 发票类型 -->
        <div class="form-row">
          <label class="form-label">{{ $t('rosRecharge.invoiceType') }}：</label>
          <span
            class="tag"
            :class="{ 'tag-active': invoiceType === 'normal' }"
            @click="setInvoiceType('normal')"
          >{{ $t('rosRecharge.generalInvoice') }}</span>
          <span
            v-if="titleType === 'company'"
            class="tag"
            :class="{ 'tag-active': invoiceType === 'special' }"
            @click="setInvoiceType('special')"
          >{{ $t('rosRecharge.specialInvoice') }}</span>
        </div>
        <!-- 抬头类型 -->
        <div class="form-row">
          <label class="form-label">{{ $t('rosRecharge.headerType') }}：</label>
          <span
            class="tag"
            :class="{ 'tag-active': titleType === 'company' }"
            @click="setTitleType('company')"
          >{{ $t('rosRecharge.companyHeader') }}</span>
          <span
            v-if="invoiceType === 'normal'"
            class="tag"
            :class="{ 'tag-active': titleType === 'personal' }"
            @click="setTitleType('personal')"
          >{{ $t('rosRecharge.personalHeader') }}</span>
        </div>
        <!-- 抬头名称/公司抬头 -->
        <div class="form-row company-name-row" v-if="titleType === 'company'">
          <label class="form-label"><span class="required">*</span>{{ $t('rosRecharge.companyHeader') }}：</label>
          <div class="company-input-wrapper">
            <input
              class="form-input"
              v-model="formData.titleName"
              :placeholder="$t('rosRecharge.pleaseInputCompanyHeader')"
              @blur="handleCompanyBlur"
            />
            <div class="company-dropdown" v-if="companyNamelistFlag && companyNameList.length > 0">
              <div
                class="company-dropdown-item"
                v-for="(item, index) in companyNameList"
                :key="index"
                @mousedown.prevent="clickcompanyName(item)"
              >
                <span class="company-item-name">{{ item.name}}</span>
                <span class="company-item-tax">{{ item.taxId}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row" v-if="titleType === 'company'">
          <label class="form-label"><span class="required">*</span>{{ $t('rosRecharge.taxNumber') }}：</label>
          <input
            class="form-input"
            v-model="formData.companyTaxNumber"
            :placeholder="$t('rosRecharge.pleaseInputTaxNumber')"
          />
        </div>
        <div class="form-row" v-if="titleType === 'personal'">
          <label class="form-label"><span class="required">*</span>{{ $t('rosRecharge.headerName') }}：</label>
          <input
            class="form-input"
            v-model="formData.titleName"
            :placeholder="$t('rosRecharge.suggestPersonalName')"
          />
        </div>
        <!-- 发票内容 -->
        <div class="form-row">
          <label class="form-label"><span class="required">*</span>{{ $t('rosRecharge.invoiceContent') }}：</label>
          <input
            class="form-input"
            readonly
            :value="invoiceContentText"
          />
        </div>
        <!-- 开票金额 -->
        <div class="form-row">
          <label class="form-label"><span class="required" v-if="titleType === 'personal'">*</span>{{ $t('rosRecharge.invoiceAmount') }}：</label>
          <input
            class="form-input"
            readonly
            :value="invoiceAmount + $t('rosRecharge.yuan')"
          />
        </div>
        <!-- 更多信息（仅公司抬头显示） -->
        <div class="form-row more-info-row" v-if="titleType === 'company'">
          <label class="form-label">{{ $t('rosRecharge.moreInfo') }}：</label>
          <div class="more-info-wrapper" :class="{ 'is-open': showMore }">
            <div class="more-info-trigger" @click="showMore = !showMore">
              <span class="more-placeholder">{{ $t('rosRecharge.remarkAddressEtc') }}</span>
              <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </div>
            <div class="more-info-content" v-show="showMore">
              <div class="more-field">
                <label class="more-label">{{ $t('rosRecharge.companyAddress') }}：</label>
                <input
                  class="form-input"
                  v-model="formData.companyAddress"
                  :placeholder="$t('rosRecharge.pleaseInputCompanyAddress')"
                />
              </div>
              <div class="more-field">
                <label class="more-label">{{ $t('rosRecharge.companyPhone') }}：</label>
                <input
                  class="form-input"
                  v-model="formData.companyPhone"
                  :placeholder="$t('rosRecharge.pleaseInputCompanyPhone')"
                />
              </div>
              <div class="more-field">
                <label class="more-label">{{ $t('rosRecharge.openingBank') }}：</label>
                <input
                  class="form-input"
                  v-model="formData.bankName"
                  :placeholder="$t('rosRecharge.pleaseInputOpeningBank')"
                />
              </div>
              <div class="more-field">
                <label class="more-label">{{ $t('rosRecharge.bankAccount') }}：</label>
                <input
                  class="form-input"
                  v-model="formData.bankAccount"
                  :placeholder="$t('rosRecharge.pleaseInputBankAccount')"
                />
              </div>
              <div class="more-field">
                <label class="more-label">{{ $t('rosRecharge.remark') }}：</label>
                <input
                  class="form-input"
                  v-model="formData.remark"
                  :placeholder="$t('rosRecharge.pleaseInputRemark')"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 电子邮箱 -->
        <div class="form-row">
          <label class="form-label"><span class="required">*</span>{{ $t('rosRecharge.email') }}：</label>
          <input
            class="form-input"
            v-model="formData.email"
            :placeholder="$t('rosRecharge.pleaseInputEmail')"
          />
        </div>
        <!-- 底部按钮 -->
        <div class="form-actions">
          <button class="btn btn-cancel" @click="handleBack">{{ $t('rosRecharge.cancel') }}</button>
          <button class="btn btn-submit" :disabled="submitDisabled" @click="handleSubmit">{{ $t('rosRecharge.submit') }}</button>
        </div>
      </div>
    </div>
    <rechargeErr-dialog
      :title="$t('rosRecharge.invoiceResult')"
      :visible.sync="showRechargeErrDialog"
      v-if="showRechargeErrDialog"
      :class="{ 'showDialog': showRechargeErrDialog, 'hideDialog': !showRechargeErrDialog }" width="30vw" noFooter
    >
    <div class="content_tishi" slot="content">
        <div class="invoice-result">
          <div class="result-icon">
            <i class="el-icon-check"></i>
          </div>
          <div class="result-title">{{ $t('rosRecharge.invoiceSubmitted') }}</div>
          <div class="result-desc">{{ $t('rosRecharge.invoiceExpectedTip') }}</div>
          <div class="result-action">
            <button type="button" class="btn btn-submit" @click="handleViewStatus">{{ $t('rosRecharge.viewInvoiceStatus') }}</button>
          </div>
        </div>
      </div>
    </rechargeErr-dialog>
  </div>
</template>
<script>
import rechargeErrDialog from "@/components/dialognew";
export default {
  name: 'invoiceForm',
  props: {
    invoiceData: {
      type: Array,
      default: () => ([])
    }
  },
  components: {
    rechargeErrDialog,
  },
  data() {
    return {
      companyNameFlag: true,
      companyNamelistFlag: false,
      companyNameList: [],
      showRechargeErrDialog: false,
      submitting: false,
      invoiceType: 'normal',
      titleType: 'company',
      showMore: false,
      // 标志位：true表示初始加载（不触发watch），false表示用户手动输入（触发watch）
      isInitialLoading: true,
      // 公司抬头表单数据
      companyFormData: {
        titleName: '',
        companyTaxNumber: '',
        companyAddress: '',
        companyPhone: '',
        bankName: '',
        bankAccount: '',
        remark: '',
        email: ''
      },
      // 个人抬头表单数据
      personalFormData: {
        titleName: '',
        email: ''
      }
    };
  },
  watch: {
    // 只监听公司抬头的 titleName（用于公司名称搜索）
    'companyFormData.titleName': {
      handler(val) {
        // 初始加载时不触发 watch，只有用户手动输入才触发
        if (this.isInitialLoading) return;
        this.handleTitleNameChange(val);
      }
    }
    // 个人抬头不需要触发监听
  },
  computed: {
    // 根据抬头类型动态返回对应的表单数据
    formData() {
      return this.titleType === 'company' 
        ? this.companyFormData 
        : this.personalFormData;
    },
    submitDisabled() {
      const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!this.formData.titleName.trim()) return true;
      if (this.titleType === 'company' && !this.formData.companyTaxNumber.trim()) return true;
      if (!this.formData.email.trim() || !emailReg.test(this.formData.email.trim())) return true;
      if (this.submitting) return true;
      return false;
    },
    invoiceAmount() {
      if (this.invoiceData && this.invoiceData.length > 0) {
        // 合计所有行的 amount
        return this.invoiceData.reduce((sum, item) => {
          return sum + (parseFloat(item.amount) || 0);
        }, 0).toFixed(2);
      }
      return '0.00';
    },
    // 发票内容文本
    invoiceContentText() {
      return '物联网通讯服务费';
    }
  },
  created() {},
  mounted() {
    this.getInfos();
  },
  methods: {
    handleBack() {
      this.$emit('back');
    },
    setInvoiceType(type) {
      this.invoiceType = type;
      if (type === 'special') {
        this.titleType = 'company';
      }
    },
    setTitleType(type) {
      this.titleType = type;
      // 个人/非企业抬头只能选普通发票
      if (type === 'personal') {
        this.invoiceType = 'normal';
      }
    },    // 获取填充信息
    getInfos() {
      this.$request
        .getINP(`/gip/api/pub/baiwang/history/companyMessage/${this.$store.state.user.uidExtra}`)
        .then(res => {
          console.log(res);
          if (res.code == 200 && res.data) {
            const data = res.data;
            // naturalMark: 0-公司抬头，1-个人抬头
            if (data.naturalMark === '0' || data.naturalMark === 0) {
              // 公司抬头数据
              this.titleType = 'company';
              this.companyFormData.titleName = data.name || '';
              this.companyFormData.companyTaxNumber = data.taxId || '';
              this.companyFormData.companyAddress = data.location || '';
              this.companyFormData.companyPhone = data.mobilePhone || '';
              this.companyFormData.bankName = data.bank || '';
              this.companyFormData.bankAccount = data.bankAccount || '';
              this.companyFormData.remark = data.remarks || '';
              this.companyFormData.email = data.email || '';
            } else if (data.naturalMark === '1' || data.naturalMark === 1) {
              // 个人抬头数据
              this.titleType = 'personal';
              this.personalFormData.titleName = data.name || '';
              this.personalFormData.email = data.email || '';
            }
          } else {
            // 获取失败，使用默认值
            this.titleType = 'company';
          }
          // 数据加载完成后，重置标志位，允许 watch 触发
          this.$nextTick(() => {
            this.isInitialLoading = false;
          });
        })
        .catch(err => {
          console.error('获取发票信息失败:', err);
          // 接口失败，使用默认值
          this.titleType = 'company';
          // 即使失败也要重置标志位
          this.$nextTick(() => {
            this.isInitialLoading = false;
          });
        });
    },
    // 获取公司
    getcompanyName(companyNames) {
      let data = {
        companyName: companyNames
      };
      this.$request
        .postINP("/gip/api/pub/baiwang/companySearch", data)
        .then(res => {
          if (res.code == 200 && res.data) {
            this.companyNameList = res.data;
            if (this.companyNameList.length > 0) {
              this.companyNamelistFlag = true;
            } else {
              this.companyNamelistFlag = false;
            }
          } else {
            this.companyNamelistFlag = false;
          }
        });
    },
    // 处理 titleName 变化（用于 watch）
    handleTitleNameChange(val) {
      console.log('titleName changed:', val);
      // 只有公司抬头且输入长度大于1时才搜索公司
      if (val && val.length > 1 && this.companyNameFlag && this.titleType === 'company') {
        if (!this._debouncedGetCompanyName) {
          this._debouncedGetCompanyName = this.debounce((v) => {
            this.getcompanyName(v);
          }, 800);
        }
        this._debouncedGetCompanyName(val);
      } else {
        this.companyNamelistFlag = false;
      }
      this.companyNameFlag = true;
    },
    // 点击选择公司
    clickcompanyName(item) {
      this.companyNameFlag = false;
      this.formData.titleName = item.name || '';
      this.formData.companyTaxNumber = item.taxId|| '';
      this.companyNamelistFlag = false;
    },
    // 输入框失焦关闭下拉
    handleCompanyBlur() {
      setTimeout(() => {
        this.companyNamelistFlag = false;
      }, 200);
    },
    // 防抖函数
    debounce(fn, delay) {
      let timer = null;
      return function (...args) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          fn.apply(this, args);
        }, delay);
      };
    },
    handleSubmit() {
      // 必填项校验
      if (!this.formData.titleName.trim()) {
        this.$message.warning(this.titleType === 'company' ? this.$t('rosRecharge.pleaseInputCompanyHeader') : this.$t('rosRecharge.pleaseInputHeaderName'));
        return;
      }
      if (this.titleType === 'company' && !this.formData.companyTaxNumber.trim()) {
        this.$message.warning(this.$t('rosRecharge.pleaseInputTaxNumber'));
        return;
      }
      if (!this.formData.email.trim()) {
        this.$message.warning(this.$t('rosRecharge.pleaseInputEmail'));
        return;
      }
      // 邮箱格式校验
      const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailReg.test(this.formData.email.trim())) {
        this.$message.warning(this.$t('rosRecharge.pleaseInputValidEmail'));
        return;
      }
      // 组装接口参数
      const submitData = {
        orderNo: this.invoiceData.map(item => item.orderNo),
        invoiceType: this.invoiceType === 'special' ? 1 : 2,
        titleType: this.titleType === 'company' ? 0 : 1,
        titleName: this.formData.titleName.trim(),
        invoiceContent: '物联网通讯服务费',
        invoiceAmount: this.invoiceAmount,
        email: this.formData.email.trim()
      };
      
      // 只有公司抬头才提交公司相关字段
      if (this.titleType === 'company') {
        submitData.companyTaxNumber = this.formData.companyTaxNumber || '';
        submitData.companyAddress = this.formData.companyAddress || '';
        submitData.companyPhone = this.formData.companyPhone || '';
        submitData.bankName = this.formData.bankName || '';
        submitData.bankNumber = this.formData.bankAccount || '';
        submitData.remarks = this.formData.remark || '';
      }
      
      console.log(submitData,"submitDatasubmitData")
      this.submitting = true;
    //   this.$emit('submit', submitData);
      this.$request
        .postDEVMicroservices("/ros/api/rechargeInvoice/applyInvoice", submitData)
        .then(res => {
          if (res.code == 0) {
            this.showRechargeErrDialog = true;
          } else {
            this.$message.error(res.message || this.$t('rosRecharge.invoiceApplyFailed'));
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    handleViewStatus() {
      this.showRechargeErrDialog = false;
    //   this.$emit('viewStatus');
      this.$router.push({ name: 'generalNewBillingHistory' });
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");

.invoice-form {
  display: flex;
  flex: 1;
  flex-direction: column;
  background: rgb(34, 45, 53);
  overflow: auto;

  .form-header {
    display: flex;
    align-items: center;
    height: 48px;
    padding: 0 16px;
    background: rgb(34, 45, 53);
    border-bottom: 1px solid rgba(198, 209, 221, 0.2);

    .back-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      cursor: pointer;
      color: #ffffff;
      font-size: 18px;

      &:hover {
        color: @primaryTextColor;
      }
    }

    .header-title {
      font-size: 16px;
      color: #ffffff;
      margin-left: 8px;
    }
  }

  .form-body {
    flex: 1;
    overflow-y: auto;
    padding: 24px 0;

    .form-content {
      max-width: 800px;
      margin: 0 auto;
      padding: 0 24px;
    }
  }

  .form-row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .form-label {
      width: 120px;
      flex-shrink: 0;
      font-size: 14px;
      color: #ffffff;
      text-align: right;
      padding-right: 12px;

      .required {
        color: #ff7c79;
        margin-right: 2px;
      }
    }

    .form-input {
      flex: 1;
      width: 100%;
      height: 36px;
      line-height: 36px;
      padding: 0 12px;
      background: #2b3842;
      border: 1px solid #7b8395;
      color: #ffffff;
      font-size: 14px;
      outline: none;
      border-radius: 4px;

      &::placeholder {
        color: #7b8395;
      }

      &[readonly] {
        border: none;
        // color: #7b8395;
        // cursor: default;
      }
    }
  }

  .company-name-row {
    position: relative;

    .company-input-wrapper {
      flex: 1;
      position: relative;

      .company-dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        max-height: 200px;
        overflow-y: auto;
        background: #2b3842;
        border: 1px solid #7b8395;
        border-top: none;
        border-radius: 0 0 4px 4px;
        z-index: 10;

        .company-dropdown-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 12px;
          cursor: pointer;
          transition: background 0.2s;

          &:hover {
            background: rgba(255, 255, 255, 0.08);
          }

          .company-item-name {
            color: #ffffff;
            font-size: 14px;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .company-item-tax {
            color: #7b8395;
            font-size: 12px;
            margin-left: 12px;
            flex-shrink: 0;
          }
        }
      }
    }
  }

  .tag {
    display: inline-block;
    background: #2b3842;
    padding: 4px 16px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    border: 1px solid #7b8395;
    color: #7b8395;
    margin-right: 12px;
    transition: all 0.2s;

    &.tag-active {
      border-color: @primaryTextColor;
      color: @primaryTextColor;
    }
  }

  .more-info-row {
    align-items: flex-start;

    .more-info-wrapper {
      flex: 1;
      background: #2b3842;
      border-radius: 4px;
      overflow: hidden;

      .more-info-trigger {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 36px;
        padding: 0 12px;
        cursor: pointer;

        .more-placeholder {
          color: #7b8395;
          font-size: 14px;
        }

        i {
          color: #7b8395;
          font-size: 14px;
          transition: transform 0.2s;
        }
      }

      .more-info-content {
        padding: 8px 12px 16px;

        .more-field {
          display: flex;
          align-items: center;
          margin-bottom: 16px;

          &:last-child {
            margin-bottom: 0;
          }

          .more-label {
            width: 120px;
            flex-shrink: 0;
            font-size: 14px;
            color: #ffffff;
            text-align: right;
            padding-right: 12px;
          }

          .form-input {
            flex: 1;
          }
        }
      }
    }
  }

  .form-actions {
    display: flex;
    justify-content: center;
    padding-top: 24px;
    gap: 20px;

    .btn {
      min-width: 100px;
      height: 36px;
      line-height: 36px;
      padding: 0 24px;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;
      border: 1px solid transparent;
      transition: all 0.2s;
    }

    .btn-cancel {
      background: transparent;
      border-color: @primaryTextColor;
      color: @primaryTextColor;

      &:hover {
        background: @primaryColorTransparency30;
      }
    }

    .btn-submit {
      background: @primaryTextColor;
      border-color: @primaryTextColor;
      color: rgb(34, 45, 53);

      &:hover {
        opacity: 0.85;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }

  .invoice-result {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0 10px;

    .result-icon {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      background: @primaryTextColor;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;

      i {
        font-size: 32px;
        color: #ffffff;
        font-weight: bold;
      }
    }

    .result-title {
      font-size: 16px;
      color: #ffffff;
      font-weight: 500;
      margin-bottom: 8px;
    }

    .result-desc {
      font-size: 13px;
      color: #7b8395;
      margin-bottom: 24px;
    }

    .result-action {
      .btn-submit {
        min-width: 120px;
        height: 36px;
        line-height: 36px;
        padding: 0 24px;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
        // border: 1px solid @primaryTextColor;
        background: @primaryTextColor;
        color: #000;
        transition: all 0.2s;
      }
    }
  }
}
</style>
